import { Injectable, inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { UserStore } from "../store/user.store";
import { AppRoutes } from "../constants";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({ providedIn: "root" })
export class AuthGuard {
  private readonly store = inject(UserStore);
  private readonly router = inject(Router);
  private readonly http = inject(HttpClient);

  private async isSessionValid(): Promise<boolean> {
    const accessToken = this.store.accessToken?.();
    if (!accessToken) return false;

    try {
      await firstValueFrom(
        this.http.get(environment.keycloakBaseUrl, {
          headers: { Authorization: `Bearer ${accessToken}` },
        }),
      );
      return true;
    } catch {
      return false;
    }
  }

  public canActivate: CanActivateFn = async (): Promise<boolean | UrlTree> => {
    const isAuthenticated = (): boolean => {
      const token = this.store.accessToken?.();
      if (!token) return false;

      try {
        const tokenData = JSON.parse(atob(token.split(".")[1])) as {
          exp: number;
        };
        return tokenData.exp * 1000 > Date.now();
      } catch {
        return false;
      }
    };

    if (!isAuthenticated() || !(await this.isSessionValid())) {
      await this.store.logout();
      return this.router.createUrlTree([AppRoutes.LOGIN]);
    }

    return true;
  };
}
